// extracted by mini-css-extract-plugin
export var button = "b8_rt";
export var button__darkBlue = "b8_ry";
export var button__edgesGrey = "b8_rz";
export var button__edgesRed = "b8_rw";
export var button__loader = "b8_rB";
export var button__red = "b8_rv";
export var button__transparent = "b8_rx";
export var loadingSpinner = "b8_rC";